<template>
    <div class="question-list p-4">
        <!-- Loading -->
        <div v-if="isLoading" class="loading-overlay">
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Caricamento...</span>
            </div>
            <div class="loading-text">Caricamento in corso...</div>
        </div>

        <ToastDialog :title="toastTitle" :message="toastMessage" :error="toastError" />


        <div class="card mb-3 shadow-sm">
            <div class="card-body py-3 px-3">
                <div class="d-flex align-items-center justify-content-between">

                    <!-- SINISTRA: titolo + filtro -->
                    <div class="d-flex align-items-center">
                        <h5 class="mb-0 me-2">
                            Archivio UOC ({{ pagination.total || 0 }})
                        </h5>

                        <button class="btn btn-outline-secondary btn-sm p-1"
                            style="border-color: #D3D3D3; font-size: 0.8rem;" @click="showFilters = !showFilters">
                            <i class="bi bi-funnel-fill"></i>
                        </button>
                    </div>
                    <button class="btn btn-outline-secondary btn-sm p-1" @click="changeView('SalaAttesaSalaUOCView')"
                        title="Vai alla vista UOC">
                        <i class="bi bi-arrow-left"></i>
                    </button>

                </div>
            </div>
        </div>
        <transition name="slide-fade">
            <UOCArchiveFilters v-show="showFilters" @filter="applyFilter" />
        </transition>

        <div class="mb-3 d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
                <label class="me-2 mb-0">Elementi per pagina:</label>
                <select class="form-select w-auto" v-model.number="pagination.perPage" @change="loadUocSessions(1)">
                    <option v-for="n in [10, 25, 50, 100]" :key="n" :value="n">{{ n }}</option>
                </select>
            </div>
            <button class="btn btn-outline-secondary btn-sm rounded-pill px-3 py-2" @click="downloadCsv"
                :disabled="isDownloading">
                <span v-if="!isDownloading">
                    <i class="bi bi-arrow-down-short me-1"></i> Scarica Csv
                </span>
                <span v-else>
                    <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Generazione in corso...
                </span>
            </button>
        </div>

        <UOCArchiveTable :items="uocSessions" :pagination="pagination" :sort-field="sortField"
            :sort-direction="sortDirection" @page-change="loadUocSessions" @sort="handleSort"
            @change-view="changeView" @update:selected-questions="selectedQuestions = $event" />
    </div>
</template>

<script>
import UOCArchiveTable from './partials/UOCArchiveTable.vue';
import ToastDialog from '../../../components/common/ToastDialog.vue';
import UOCArchiveFilters from './partials/UOCArchiveFilters.vue';


export default {
    name: 'UOCArchiveView',
    components: {
        UOCArchiveTable,
        ToastDialog,
        UOCArchiveFilters
    },
    data() {
        return {
            isLoading: true,
            uocSessions: [],
            pagination: {
                currentPage: 1,
                perPage: 10,
                total: 0,
                lastPage: 1
            },
            sortField: 'date',
            sortDirection: 'desc',
            toastTitle: '',
            toastMessage: '',
            toastError: false,
            isDownloading: false,
            currentFilters: {
                date_from: '',
                date_to: '',
                object: '',
                tipo: '',
                notes: ''
            },
            showFilters: false,
            selectedQuestions: []
        }
    },
    created() {
        this.loadUocSessions(1)
    },
    methods: {
        async downloadCsv() {
            this.isDownloading = true

            try {
                const params = {
                    sortField: this.sortField,
                    sortDirection: this.sortDirection,
                    selected_ids: this.selectedQuestions,
                    ...this.currentFilters
                }

                const response = await this.$root.$api.get(
                    '/uoc/sessions/archive/export-csv',
                    { params, responseType: 'blob' }
                )

                const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' })
                const url = window.URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = url
                link.download = 'Archivio_UOC.csv'
                link.click()
                window.URL.revokeObjectURL(url)

            } catch (e) {
                this.toastTitle = 'Errore'
                this.toastMessage = 'Errore durante il download CSV'
                this.toastError = true
            } finally {
                this.isDownloading = false
            }
        }
        ,
        changeView(viewName, id) {
            console.log('Evento ricevuto:', viewName, id);
            this.$emit('change-view', viewName, id);
        },
        applyFilter(filters) {
            this.currentFilters = { ...filters }
            this.pagination.currentPage = 1
            this.loadUocSessions(1)
        },
        async loadUocSessions(page = 1) {
            this.isLoading = true
            try {
                const params = {
                    page,
                    per_page: this.pagination.perPage,
                    sortField: this.sortField,
                    sortDirection: this.sortDirection,
                    ...this.currentFilters
                };
                const res = await this.$root.$api.get('/uoc/sessions/archive', { params });

                this.uocSessions = res.data.data
                this.pagination = {
                    currentPage: res.data.current_page,
                    perPage: res.data.per_page,
                    total: res.data.total,
                    lastPage: res.data.last_page
                };
            } catch (e) {
                this.toastTitle = 'Errore'
                this.toastMessage = 'Errore nel caricamento dello storico UOC'
                this.toastError = true
            } finally {
                this.isLoading = false
            }
        },

        handleSort({ field, direction }) {
            this.sortField = field
            this.sortDirection = direction
            this.loadUocSessions(1)
        }
    }
}
</script>
<style scoped>
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 2000;
}

.loading-text {
    margin-top: 1rem;
    font-weight: bold;
    color: #0d6efd;
}

.question-list table thead {
    background-color: #0d6efd !important;
    color: white !important;
}

.question-list ::v-deep(table thead th) {
    text-align: center !important;
    vertical-align: middle !important;
}

.question-list table tbody tr:hover {
    background-color: #f1f5fb;
    transition: background-color 0.2s ease;
}

.question-list ::v-deep(.table-card table th),
.question-list ::v-deep(.table-card table td) {
    text-align: center;
    padding: 0.75rem 1rem;
}
</style>
